import { axios } from '../../api/axios'

const companyInvitationsEndpoint = '/companyInvitations'

const getCompanyInvitationsUserRegistrationStatus = (prospectId: string, userEmail: string): Promise<{ userRegistered: boolean }> => {
    return axios.get(`${companyInvitationsEndpoint}/${prospectId}/user/${userEmail}`)
}

export { getCompanyInvitationsUserRegistrationStatus }
